import { render } from "./hygieneImgDialog.vue?vue&type=template&id=c4fc0608"
import script from "./hygieneImgDialog.vue?vue&type=script&lang=js"
export * from "./hygieneImgDialog.vue?vue&type=script&lang=js"

import "./hygieneImgDialog.vue?vue&type=style&index=0&id=c4fc0608&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__